import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            {/* <div className="col-12">
              © {new Date().getFullYear()} PULA<span className="d-none d-sm-inline-block"> - Designed 
              {" "}<i className="mdi mdi-heart text-danger"></i> by Autuskey.</span>
            </div> */}
            <div className="col-12">
              © {new Date().getFullYear()} PULA
              <span className="d-none d-sm-inline-block">
                {" "} . Designed with {" "}
                <i className="mdi mdi-heart text-danger"></i> by{" "}
                <a
                  href="https://autuskey.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Technology Partners - Autuskey"
                  aria-label="Technology Partners - Autuskey"
                >
                  Autuskey
                </a>.
              </span>
            </div>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
